import { useMutation } from "@apollo/client";
import { APPLY_PROMO } from "gql/promo.gql";
import { ApplyPromo, ApplyPromoVariables } from "gql/types/ApplyPromo";
import { CustomMutationHook } from "../graphql.hook.type";
import { UseApplyPromoResult } from "./promo.hook.types";

export const useApplyPromo: CustomMutationHook<any, UseApplyPromoResult> = ({
    options = {},
} = {}) => {
    const [applyPromo, mutationData] = useMutation<
        ApplyPromo,
        ApplyPromoVariables
    >(APPLY_PROMO, {
        ...options,
    });
    return {
        ...mutationData,
        applyPromo: ({ promoCode }: any) => {
            applyPromo({
                variables: {
                    promoCode,
                },
            });
        },
    };
};
